























import {
  defineComponent,
  computed,
  ref,
  PropType,
  useRoute,
  watch,
  useContext
} from '@nuxtjs/composition-api';
import Emitter from '@/hooks/useEmitter';
import { useTranslations } from '@vue-storefront/novulo';
import { StatusReference } from '@/helpers/utils';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export default defineComponent({
  name: 'BuySectionDelivery',
  props: {
    product: {
      type: Object,
      default: () => ({
        name: '',
        status: 'Op voorraad',
        manufacturers_suggested_retail_price: 0,
        first_price: 0,
        price: 0,
        price_after_cash_discount: 0,
        price_after_cashback_discount: 0,
        variations: [],
        spli_guid: '',
        spli_id: 0,
        sku: ''
      })
    },
    statusReference: {
      type: Number as PropType<StatusReference>,
      default: StatusReference.IN_STOCK
    }
  },
  setup(props) {
    const route = useRoute();
    const isVisibleModal = ref(false);
    const useEmitter = Emitter();

    const { translate } = useTranslations();

    const { i18n } = useContext();
    const formatUrl = useUrlFormatter();

    const isAvailable = computed(() => {
      return (
        props.statusReference === StatusReference.IN_STOCK ||
        props.statusReference === StatusReference.ON_ORDER
      );
    });

    const isTemporarilySoldOut = computed(
      () => props.statusReference === StatusReference.TEMPORARILY_SOLD_OUT
    );

    watch(useEmitter.modalPickUp, () => {
      if (isAvailable.value) isVisibleModal.value = true;
    });

    const deliveryInfo = computed(() => {
      switch (props.statusReference) {
        case StatusReference.IN_STOCK:
        case StatusReference.ON_ORDER:
          return {
            text: translate('reserve_and_pick_up'),
            icon: 'IconsSocialStoresIcon24px'
          };
        case StatusReference.TEMPORARILY_SOLD_OUT:
          return {
            text: translate('stay_informed_about_the_product_stock'),
            icon: 'IconsSocialMail'
          };
        default:
          return null;
      }
    });

    const closeModal = () => {
      isVisibleModal.value = false;
    };
    const handleRedirect = (storeId: number) => {
      const url = `/${i18n.t('delivery_pickup_url')}/${
        props.product.sku
      }/${storeId}/${route.value.params.slug}`;
      window.location.href = formatUrl(url);
    };
    return {
      deliveryInfo,
      isVisibleModal,
      closeModal,
      handleRedirect,
      isAvailable,
      isTemporarilySoldOut,
      openModal: () => {
        isVisibleModal.value = true;
      }
    };
  }
});
